import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, catchError, finalize, map, of, shareReplay, throwError } from 'rxjs';
import { Banks } from 'src/app/_models/company/banks';
import { Certificati_Pagamento_Filtro } from 'src/app/helpdesk_rfi/tickets/certificati_pagamento/_models/certificati_pagamento_filtro';
import { Detached } from 'src/app/_models/company/detached';
import { Doctors } from 'src/app/_models/company/doctors';
import { Employee } from 'src/app/_models/company/employee';
import { Role } from 'src/app/_models/portal/Role.model';
import { ServicePreset } from 'src/app/_models/ServicePreset.model';
import { Page } from 'src/app/_models/ServicePresetPage.model';
import { User } from 'src/app/_models/User.model';
import { Worksite } from 'src/app/_models/Worksite.model';
import { SpinnerService } from 'src/app/_services/SpinnerService';
import { Category } from 'src/app/workflow/_models/Category';
import { Company } from '../../_models/company/company';
import { Office } from '../../_models/company/office';
import { Scan } from '../../_models/company/scan.model';
import { Service } from '../../_models/company/Service';
import { Supplier } from '../../_models/company/supplier';
import { WorksiteReport } from '../../_models/company/WorksiteRecord';
import { ConfigService } from '../../_services/config.service';

import { Collaborator } from 'src/app/_models/company/collaborator';
import { Customer } from 'src/app/_models/company/customer';
import { Gara } from 'src/app/_models/Gara.model';
import { PaymentConfig } from 'src/app/_models/company/payment-config';
import { ChatContext } from 'src/app/messaging/_models/messaging.model';

@Injectable({
	providedIn: 'root',
})
export class CompaniesService {
	authorizated = false;
	public token: string = '';
	reload = new Subject<boolean>();
	private mUrl: string = '';

	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private spinnerService: SpinnerService,
	) {}

	set_reload(r: any) {
		this.reload.next(r);
	}

	GetListCompanies(cmd_id_default: number, txtsearch: string, order_by: string, limit: number, offset: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}companies/list/${cmd_id_default}?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListAllCompanies(): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}companies/listall`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetListCollaborators(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, sup_id: number, cst_id: number = 0): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}collaborators/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&sup_id=${sup_id}&cst_id=${cst_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListWorksiteRecord(date: number, txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, data_da: number, data_a: number, ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/recordlist_web?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&date=${date} &data_da=${data_da}&data_a=${data_a}&ws_id=${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListLocationRecord(date: number, txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, data_da: number, data_a: number, org_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}locations/recordlist_web?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&date=${date} &data_da=${data_da}&data_a=${data_a}&org_id=${org_id}`, { observe: 'response' })
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetListRecordHome(cmp_id: number, data_da: number, data_a: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/get_record_home?data_da=${data_da}&data_a=${data_a}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksiteRecord(wsre_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}worksite/record/${wsre_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	getWorksiteByScan(wsre_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}worksite/wsbyscan/${wsre_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	saveWorksiteRecord(scan: Scan): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/saverecord/`;
		return this.http.post(this.mUrl, scan, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	confirmWorksiteRecord(scan: Scan): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/updrecord`;
		return this.http.post(this.mUrl, scan, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addTimbraturaManuale(lst_scan: Scan[]): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/saverecord_manually`;
		return this.http.post(this.mUrl, lst_scan, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delWorksiteRecord(wsre_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/delrecord/${wsre_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** categoria ('RFI' | 'EDIL' | '') restringe la lista; il server ignora il parametro per chi ha la categoria forzata dal ruolo. */
	GetWorksiteListAll(cmp_id: number, categoria: string = ''): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/listall?cmp_id=${cmp_id}&categoria=${encodeURIComponent(categoria || '')}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Suddivisione cantieri RFI/EDIL per l'azienda: { enabled, forced, canChoose, ptIdReferenced, currentPtId }.
	 * canChoose = l'utente puo' cambiare il filtro categoria / scegliere la categoria nel form (admin o manager cantieri).
	 */
	GetWorksiteCategoriaInfo(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/categoria-info?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Il termine di ricerca guarda nome, descrizione, CIG e CUP del cantiere.
	 * Filtri opzionali (rapportini, 16/10/2026), applicati dalla funzione PG: wsLevel = 0 solo cantieri padre,
	 * > 0 figli di quel padre; soloAperti = solo cantieri in stato aperto. Senza opzioni la lista e' quella di sempre.
	 */
	GetListWorksite(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, lot_id: number, showSpinner: boolean = true, filtri?: { wsLevel?: number | null; soloAperti?: boolean }): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		// showSpinner = false vale anche per lo spinner dell'interceptor (header X-No-Spinner), come GetListSuppliers
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		let extra = '';
		if (filtri?.wsLevel !== undefined && filtri.wsLevel !== null) extra += `&ws_level=${filtri.wsLevel}`;
		if (filtri?.soloAperti) extra += '&solo_aperti=true';
		return this.http
			.get(`${this.configService.companiesUrl}worksite/list?txtsearch=${encodeURIComponent(txtsearch || '')}&order_by=${encodeURIComponent(order_by || '')}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&lot_id=${lot_id}${extra}`, { observe: 'response', headers })
			.pipe(
				map((response) => response.body),
				finalize(() => {
					if (showSpinner) this.spinnerService.hide();
				}),
			);
	}

	/**
	 * Lista cantieri ad albero, paginata server-side per cantiere PADRE
	 * (un padre = 1 elemento anche con 100 discendenti), con annidamento su 2 livelli
	 * e filtro stato applicato dal server. Usata solo dalla pagina lista cantieri:
	 * per tendine e autocomplete continuare a usare GetListWorksite.
	 */
	/** sort/dir: ordinamento per colonna lato server (vuoto = per nome, l'ordine di sempre) */
	GetWorksiteTree(txtsearch: string, stato: number, limit: number, offset: number, cmp_id: number, lot_id: number, categoria: string = '', sort: string = '', dir: string = ''): Observable<any> {
		this.spinnerService.show();
		const ordine = sort ? `&sort=${encodeURIComponent(sort)}&dir=${encodeURIComponent(dir || 'ASC')}` : '';
		return this.http
			.get(`${this.configService.companiesUrl}worksite/list-tree?txtsearch=${encodeURIComponent(txtsearch || '')}&stato=${stato}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&lot_id=${lot_id}&categoria=${encodeURIComponent(categoria || '')}${ordine}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetListWorksiteByCigCup(cig: string, cup: string, cmp_id: number): Observable<any> {
		const params = new URLSearchParams({ cig, cup, cmp_id: String(cmp_id) });
		return this.http.get(`${this.configService.companiesUrl}worksite/by-cig-cup?${params.toString()}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Versione flessibile: matcha cantieri anche se solo CIG o solo CUP è valorizzato.
	 * Usato dall'upload cartella SAL Attivo per matchare il cantiere dopo estrazione AI.
	 */
	FindWorksiteByCigCup(cig: string | null, cup: string | null, cmp_id: number): Observable<any> {
		const params = new URLSearchParams({ cmp_id: String(cmp_id) });
		if (cig) params.set('cig', cig);
		if (cup) params.set('cup', cup);
		return this.http.get(`${this.configService.companiesUrl}worksite/find-by-cig-cup?${params.toString()}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Massimo progressivo cumulato fra i SAL precedenti dello stesso cantiere.
	 * Usato per derivare il delta del SAL corrente: delta = progressivo - maxPrev.
	 * Ritorna { res: <BigDecimal> }.
	 */
	GetMaxProgressivoBefore(cmp_id: number, ws_id: number, exclude_sal_id?: number, before_date?: string): Observable<any> {
		const params = new URLSearchParams({ cmp_id: String(cmp_id), ws_id: String(ws_id) });
		if (exclude_sal_id != null) params.set('exclude_sal_id', String(exclude_sal_id));
		if (before_date) params.set('before_date', before_date);
		return this.http.get(`${this.configService.companiesUrl}sal/max-progressivo-before?${params.toString()}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Ritorna il prefill bundle a partire dal cantiere: contract, categories,
	 * withholdings, advances, subcontracts, contacts, quote/supplier, residui.
	 * Usato per pre-popolare i form SAL / CEL / CertPayment al cambio cantiere.
	 */
	GetWorksiteContractDetail(ws_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/${ws_id}/contract-detail`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/**
	 * Ritorna il prefill bundle a partire dal contratto (flusso "contract first").
	 * Se ws_id è fornito, la quote scelta corrisponde a quel cantiere; altrimenti
	 * il bundle include tutte le quote del contratto per consentire la scelta.
	 */
	GetContractPrefillBundle(cnt_id: number, ws_id: number = 0): Observable<any> {
		const params = new URLSearchParams();
		if (ws_id > 0) params.set('ws_id', String(ws_id));
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/${cnt_id}/prefill${qs}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	// ============================== CEL ==============================

	GetCelList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('order_by', filter.order_by || '');
		params.set('limit', String(filter.limit ?? 20));
		params.set('offset', String(filter.offset ?? 0));
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.protocolDateFrom) params.set('protocolDateFrom', filter.protocolDateFrom);
		if (filter.protocolDateTo) params.set('protocolDateTo', filter.protocolDateTo);
		if (filter.settore !== null && filter.settore !== undefined) params.set('settore', String(filter.settore));
		if (filter.protocollo) params.set('protocollo', filter.protocollo);
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.rcl) params.set('rcl', filter.rcl);
		if (filter.stazione_appaltante_id) params.set('stazione_appaltante_id', String(filter.stazione_appaltante_id));
		if (filter.workStartDateFrom) params.set('workStartDateFrom', filter.workStartDateFrom);
		if (filter.workStartDateTo) params.set('workStartDateTo', filter.workStartDateTo);
		if (filter.workEndDateFrom) params.set('workEndDateFrom', filter.workEndDateFrom);
		if (filter.workEndDateTo) params.set('workEndDateTo', filter.workEndDateTo);
		return this.http.get(`${this.configService.companiesUrl}cel/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetCel(cel_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cel/get/${cel_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddCel(cel: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}cel/add`, cel, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdCel(cel_id: number, cel: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cel/upd/${cel_id}`, cel, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelCel(cel_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}cel/del/${cel_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Verifica univocità protocollo CEL (replica DNN ExistProtocollo).
	 * Ritorna { exists: bool }.
	 */
	CheckCelProtocolloExists(cmp_id: number, protocollo: string, cel_id: number): Observable<any> {
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		params.set('protocollo', protocollo);
		params.set('cel_id', String(cel_id || 0));
		return this.http.get(`${this.configService.companiesUrl}cel/exist-protocollo?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Genera PDF singolo CEL. */
	GenerateCelPdfSingle(cel_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}cel/pdf/single/${cel_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF lista CEL filtrata (stesso set di filtri di GetCelList). */
	GenerateCelPdfList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.txtsearch) params.set('txtsearch', filter.txtsearch);
		if (filter.protocolDateFrom) params.set('protocolDateFrom', filter.protocolDateFrom);
		if (filter.protocolDateTo) params.set('protocolDateTo', filter.protocolDateTo);
		if (filter.settore !== null && filter.settore !== undefined) params.set('settore', String(filter.settore));
		if (filter.protocollo) params.set('protocollo', filter.protocollo);
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.rcl) params.set('rcl', filter.rcl);
		if (filter.stazione_appaltante_id) params.set('stazione_appaltante_id', String(filter.stazione_appaltante_id));
		if (filter.workStartDateFrom) params.set('workStartDateFrom', filter.workStartDateFrom);
		if (filter.workStartDateTo) params.set('workStartDateTo', filter.workStartDateTo);
		if (filter.workEndDateFrom) params.set('workEndDateFrom', filter.workEndDateFrom);
		if (filter.workEndDateTo) params.set('workEndDateTo', filter.workEndDateTo);
		return this.http.get(`${this.configService.companiesUrl}cel/pdf/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetContractorRoles(): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cel/contractor-roles`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	GetAwardeeTypes(): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cel/awardee-types`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	// =============== Sub-Affidamenti ===============

	GetSubAffList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('order_by', filter.order_by || '');
		params.set('limit', String(filter.limit ?? 20));
		params.set('offset', String(filter.offset ?? 0));
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.sup_id) params.set('sup_id', String(filter.sup_id));
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.status !== null && filter.status !== undefined) params.set('status', String(filter.status));
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		return this.http.get(`${this.configService.companiesUrl}sub-aff/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetSubAff(sub_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sub-aff/get/${sub_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddSubAff(s: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sub-aff/add`, s, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdSubAff(sub_id: number, s: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sub-aff/upd/${sub_id}`, s, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelSubAff(sub_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}sub-aff/del/${sub_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF singolo Sub-Affidamento (replica DNN "Stampa Sub-Aff"). */
	GenerateSubAffPdfSingle(sub_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}sub-aff/pdf/single/${sub_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Verifica residuo subappaltabile del Contratto Applicativo (replica DNN controllaResiduo).
	 * Ritorna { ok, message, gia_subappaltato, nuovo_totale, soglia, supero }.
	 */
	CheckSubAffResiduo(cnt_id: number, sub_id: number, importo: number): Observable<any> {
		const params = new URLSearchParams();
		params.set('cnt_id', String(cnt_id || 0));
		params.set('sub_id', String(sub_id || 0));
		params.set('importo', String(importo || 0));
		return this.http.get(`${this.configService.companiesUrl}sub-aff/check-residuo?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Genera PDF lista Sub-Affidamenti filtrata (replica DNN generaPDF Subaffidamenti). */
	GenerateSubAffPdfList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(filter.cmp_id || 0));
		if (filter.txtsearch) params.set('txtsearch', filter.txtsearch);
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.sup_id) params.set('sup_id', String(filter.sup_id));
		if (filter.status != null) params.set('status', String(filter.status));
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		return this.http.get(`${this.configService.companiesUrl}sub-aff/pdf/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== SAL (attivi) ===============

	GetSalList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('order_by', filter.order_by || '');
		params.set('limit', String(filter.limit ?? 20));
		params.set('offset', String(filter.offset ?? 0));
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.cst_id) params.set('cst_id', String(filter.cst_id));
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.dateFromMin) params.set('dateFromMin', filter.dateFromMin);
		if (filter.dateFromMax) params.set('dateFromMax', filter.dateFromMax);
		if (filter.dateToMin) params.set('dateToMin', filter.dateToMin);
		if (filter.dateToMax) params.set('dateToMax', filter.dateToMax);
		if (filter.da_abbinare) params.set('da_abbinare', 'true');
		return this.http.get(`${this.configService.companiesUrl}sal/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Quanti SAL hanno un abbinamento possibile a una proposta di SAL (avviso della lista, lm_16) */
	CountSalDaAbbinare(cmp_id: number): Observable<number> {
		return this.http.get<number>(`${this.configService.companiesUrl}sal/da-abbinare?cmp_id=${cmp_id}`);
	}

	GetSal(sal_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sal/get/${sal_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddSal(sal: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sal/add`, sal, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdSal(sal_id: number, sal: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal/upd/${sal_id}`, sal, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelSal(sal_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}sal/del/${sal_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF singolo SAL Attivo (replica DNN "Stampa SAL"). */
	GenerateSalPdfSingle(sal_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}sal/pdf/single/${sal_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF lista SAL Attivi filtrata. */
	GenerateSalPdfList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.txtsearch) params.set('txtsearch', filter.txtsearch);
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.sup_id) params.set('sup_id', String(filter.sup_id));
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.dateFromMin) params.set('dateFromMin', filter.dateFromMin);
		if (filter.dateFromMax) params.set('dateFromMax', filter.dateFromMax);
		if (filter.dateToMin) params.set('dateToMin', filter.dateToMin);
		if (filter.dateToMax) params.set('dateToMax', filter.dateToMax);
		return this.http.get(`${this.configService.companiesUrl}sal/pdf/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== SAL Passivi ===============

	GetSalPassivoList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('order_by', filter.order_by || '');
		params.set('limit', String(filter.limit ?? 20));
		params.set('offset', String(filter.offset ?? 0));
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.sub_id) params.set('sub_id', String(filter.sub_id));
		if (filter.sup_id) params.set('sup_id', String(filter.sup_id));
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.status !== null && filter.status !== undefined) params.set('status', String(filter.status));
		if (filter.type !== null && filter.type !== undefined) params.set('type', String(filter.type));
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== Lavorazioni dei cantieri normali (dentro il cantiere) ===============

	GetLavorazioni(cmp_id: number, ws_id: number, sup_id: number | null = null, stato: number | null = null): Observable<any> {
		const params = new URLSearchParams({ cmp_id: String(cmp_id), ws_id: String(ws_id) });
		if (sup_id) params.set('sup_id', String(sup_id));
		if (stato !== null && stato !== undefined) params.set('stato', String(stato));
		return this.http.get(`${this.configService.companiesUrl}lavorazioni/list?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	GetLavorazione(lav_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}lavorazioni/get/${lav_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Nuova (lav_id 0) o modificata, con le voci. Restituisce lav_id. */
	SaveLavorazione(lav: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}lavorazioni/save`, lav, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** stato 1 = completata, 0 = riaperta. */
	SetStatoLavorazione(lav_id: number, stato: number): Observable<any> {
		return this.http.put(`${this.configService.companiesUrl}lavorazioni/stato/${lav_id}/${stato}`, {}, { observe: 'response' }).pipe(map((r) => r.body));
	}

	DelLavorazione(lav_id: number): Observable<any> {
		return this.http.delete(`${this.configService.companiesUrl}lavorazioni/del/${lav_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	SetFolderLavorazione(lav_id: number, folder_id: number): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}lavorazioni/setfolder?lav_id=${lav_id}&folder_id=${folder_id}`, {}, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** SAL passivo (categoria LAVORAZIONE) dalle lavorazioni completate di un fornitore. Restituisce slp_id. */
	CreaSalDaLavorazioni(cmp_id: number, lav_ids: number[]): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}lavorazioni/crea-sal`, { cmp_id, lav_ids }, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Categorie dei SAL passivi (SAL, Nolo, Servizio...). */
	GetSalPassivoCategorie(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/categorie/${cmp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	GetSalPassivo(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/get/${slp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== Collegamento Fattura ↔ SAL Passivo (bidirezionale) ===============

	/** Fatture passive candidate per essere collegate al SAL (stesso cantiere+fornitore, non assegnate). */
	GetInvoiceCandidatesForSal(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/${slp_id}/invoice-candidates`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Fattura attualmente collegata al SAL (null se nessuna). */
	GetLinkedInvoiceForSal(slp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/${slp_id}/linked-invoice`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Set/unset slp_inv_id. sf_id=0 → scollega (NULL). */
	LinkInvoiceToSal(slp_id: number, sf_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sal-passivo/${slp_id}/link-invoice/${sf_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** SAL Passivi candidati per essere collegati alla fattura. */
	GetSalCandidatesForInvoice(sf_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}scadenziario-fatture/${sf_id}/sal-candidates`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** SAL Passivo collegato a una fattura (null se nessuno). */
	GetLinkedSalForInvoice(sf_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}scadenziario-fatture/${sf_id}/linked-sal`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** CdP collegato a una fattura attiva (con SAL attivo e contratto): body null (204) se la fattura non viene da un CdP. */
	GetCertPaymentByInvoice(fat_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cert-payment/by-invoice/${fat_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** CdP candidati al collegamento con una fattura attiva (senza fattura, stesso cliente/cantiere). */
	GetCertPaymentCandidatesForInvoice(fat_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cert-payment/candidates-for-invoice/${fat_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Scollega la fattura attiva dal CdP senza eliminarla (ctp_fat_id=NULL, stato Inviato). */
	UnlinkCertPaymentInvoice(origin: string, ctp_id: number): Observable<any> {
		return this.http.put(`${this.configService.companiesUrl}cert-payment/unlink-invoice/${origin}/${ctp_id}`, {}, { observe: 'response' }).pipe(map((r) => r.body));
	}

	AddSalPassivo(slp: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sal-passivo/add`, slp, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdSalPassivo(slp_id: number, slp: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo/upd/${slp_id}`, slp, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Salvadanaio per categoria: { contratto: {appaltabile, usato, residuo}, subaff: {importo, usato, residuo} } (escluso slp_id). */
	GetSalPassivoSalvadanaio(cat_id: number, cnt_id: number, sub_id: number, slp_id: number, lav_id = 0): Observable<any> {
		const p = new URLSearchParams({ cat_id: String(cat_id) });
		if (cnt_id) p.set('cnt_id', String(cnt_id));
		if (sub_id) p.set('sub_id', String(sub_id));
		if (slp_id > 0) p.set('slp_id', String(slp_id));
		if (lav_id > 0) p.set('lav_id', String(lav_id));
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/salvadanaio?${p.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Per la conferma di eliminazione: { seq, categoria, riferimento, ultimo, certificati }. */
	GetSalPassivoNumerazione(slp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/numerazione/${slp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	DelSalPassivo(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}sal-passivo/del/${slp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	PublishSalPassivoBozza(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo/publish-bozza/${slp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	ClearSalPassivoBozza(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo/clear-bozza/${slp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Cambio stato manuale SAL Passivo (replica SP DNN salpassivo_updstato).
	 * Valori: 0=DA_AUTORIZZARE, 1=AUTORIZZATO, 2=FATTURATO.
	 */
	UpdateSalPassivoStato(slp_id: number, stato: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo/stato/${slp_id}/${stato}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF SAL Passivo singolo. Backend ritorna { res: filename }, da aprire via imageBaseURL + '/temp/'. */
	GenerateSalPassivoPdfSingle(slp_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/pdf/single/${slp_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Genera PDF Certificato di Pagamento (replica DNN GeneraPDFSalPassivo_CertificatoPagamento).
	 * Lato server setta anche slp_cert_gen = true. Param data formato "dd/MM/yyyy".
	 */
	GenerateSalPassivoCertPagamentoPdf(slp_id: number, cmp_id: number, data?: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		if (data) params.set('data', data);
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/pdf/cert-pagamento/${slp_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Genera PDF Riepilogo+Libretto Misure (replica DNN GeneraRiepilogoELibrettoMisure).
	 * Lato server setta anche slp_cert_gen = true.
	 */
	GenerateSalPassivoRiepilogoLibrettoPdf(slp_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/pdf/riepilogo-libretto/${slp_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Certificati di pagamento agganciati al SAL passivo (cert_payment.ctp_slp_id). */
	GetCertificatiBySalPassivo(slp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/${slp_id}/certificati`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Annulla generazione certificato (replica DNN AnnullaGenerazioneCertificato). */
	AnnullaSalPassivoCertGen(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo/cert-gen/annulla/${slp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== SAL Passivo Ordini (righe dettaglio, replica DNN ga_ordini) ===============

	/** Lista ordini di un SAL Passivo. */
	GetSalPassivoOrdini(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sal-passivo-ordini/list/${slp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Totale importo ordini di un SAL Passivo. */
	GetSalPassivoOrdiniTotale(slp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}sal-passivo-ordini/totale/${slp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	AddSalPassivoOrdine(ord: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sal-passivo-ordini/add`, ord, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdSalPassivoOrdine(ord_id: number, ord: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}sal-passivo-ordini/upd/${ord_id}`, ord, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelSalPassivoOrdine(ord_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}sal-passivo-ordini/del/${ord_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== SAL Passivo Note (replica DNN ViewNote/SaveNota/printNote) ===============

	/** Lista note del SAL Passivo. */
	GetSalPassivoNote(slp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/note/${slp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Aggiunge una nota al SAL Passivo (DNN: SaveNota). */
	AddSalPassivoNota(slp_id: number, testo: string): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}sal-passivo/note/${slp_id}`, { testo }, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Lista TUTTE le rate (pagate + non) di una fattura (replica DNN ViewRateFattura).
	 * Popola popup nel form SAL Passivo se slp_inv_id è valorizzato.
	 */
	GetRateFattura(idFattura: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}scadenziario-fatture/rate-all/${idFattura}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF stampa note (DNN: printNote). */
	GenerateSalPassivoNotePdf(slp_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/note/pdf/${slp_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Esporta CSV della lista SAL Passivi filtrata. */
	ExportSalPassivoCsv(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(filter.cmp_id || 0));
		if (filter.txtsearch != null) params.set('txtsearch', filter.txtsearch);
		if (filter.sub_id != null) params.set('sub_id', String(filter.sub_id));
		if (filter.sup_id != null) params.set('sup_id', String(filter.sup_id));
		if (filter.ws_id != null) params.set('ws_id', String(filter.ws_id));
		if (filter.cnt_id != null) params.set('cnt_id', String(filter.cnt_id));
		if (filter.status != null) params.set('status', String(filter.status));
		if (filter.type != null) params.set('type', String(filter.type));
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/csv/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Genera PDF della lista SAL Passivi filtrata. */
	GenerateSalPassivoPdfList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmp_id', String(filter.cmp_id || 0));
		if (filter.txtsearch != null) params.set('txtsearch', filter.txtsearch);
		if (filter.sub_id != null) params.set('sub_id', String(filter.sub_id));
		if (filter.sup_id != null) params.set('sup_id', String(filter.sup_id));
		if (filter.ws_id != null) params.set('ws_id', String(filter.ws_id));
		if (filter.cnt_id != null) params.set('cnt_id', String(filter.cnt_id));
		if (filter.status != null) params.set('status', String(filter.status));
		if (filter.type != null) params.set('type', String(filter.type));
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		return this.http.get(`${this.configService.companiesUrl}sal-passivo/pdf/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== Cert Payment (federato: companydb + foreign RFI _em/_l via FDW) ===============

	/** Importo del SAL passivo, quanto e' gia' certificato e quanto resta da certificare. */
	GetResiduoSalPassivo(slp_id: number, escludi_ctp_id: number | null = null): Observable<any> {
		const params = new URLSearchParams();
		if (escludi_ctp_id && escludi_ctp_id > 0) params.set('escludi_ctp_id', String(escludi_ctp_id));
		return this.http.get(`${this.configService.companiesUrl}cert-payment/sal-passivo/${slp_id}/residuo?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Residuo del cantiere (capienza da certificare) e residuo del contratto (non assegnato). */
	GetResiduiCdp(cmp_id: number, ws_id: number, cnt_id: number | null = null): Observable<any> {
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		params.set('ws_id', String(ws_id));
		if (cnt_id && cnt_id > 0) params.set('cnt_id', String(cnt_id));
		return this.http.get(`${this.configService.companiesUrl}cert-payment/residui?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/**
	 * Dice se il cantiere e' un accordo quadro e, in tal caso, elenca i cantieri figli con il
	 * loro contratto applicativo. Il certificato va emesso su uno di quelli.
	 */
	GetAccordoQuadro(ws_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cert-payment/accordo-quadro/${ws_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Acconti dello stesso fornitore e cantiere con quota ancora disponibile da recuperare. */
	GetAccontiDisponibiliCdp(sup_id: number, ws_id: number, ctp_id: number | null = null): Observable<any> {
		const params = new URLSearchParams();
		params.set('sup_id', String(sup_id));
		params.set('ws_id', String(ws_id));
		if (ctp_id && ctp_id > 0) params.set('ctp_id', String(ctp_id));
		return this.http.get(`${this.configService.companiesUrl}cert-payment/acconti-disponibili?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Dettaglio del recupero di un CdP: da quali acconti ha preso e quanto. */
	GetAccontiDiCertificato(ctp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cert-payment/${ctp_id}/acconti`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** Numero suggerito per un nuovo CdP (max+1 per cantiere + fornitore). */
	GetNextNumeroCdp(ws_id: number, sup_id: number, tipologia: number = 1): Observable<any> {
		const params = new URLSearchParams();
		params.set('ws_id', String(ws_id));
		params.set('sup_id', String(sup_id));
		params.set('tipologia', String(tipologia));
		return this.http.get(`${this.configService.companiesUrl}cert-payment/next-numero?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	GetCertPaymentList(filter: any): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('order_by', filter.order_by || '');
		params.set('limit', String(filter.limit ?? 20));
		params.set('offset', String(filter.offset ?? 0));
		params.set('cmp_id', String(filter.cmp_id ?? -1));
		if (filter.sup_id) params.set('sup_id', String(filter.sup_id));
		if (filter.cst_id) params.set('cst_id', String(filter.cst_id));
		if (filter.ws_id) params.set('ws_id', String(filter.ws_id));
		if (filter.sal_id) params.set('sal_id', String(filter.sal_id));
		if (filter.slp_id) params.set('slp_id', String(filter.slp_id));
		if (filter.cnt_id) params.set('cnt_id', String(filter.cnt_id));
		if (filter.stato !== null && filter.stato !== undefined) params.set('stato', String(filter.stato));
		if (filter.tipologia !== null && filter.tipologia !== undefined) params.set('tipologia', String(filter.tipologia));
		if (filter.origin) params.set('origin', filter.origin);
		if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
		if (filter.dateTo) params.set('dateTo', filter.dateTo);
		// ordinamento per colonna (contratto|cliente|fornitore|data|numero|importo|...): solo se diverso dal default
		if (filter.sort) {
			params.set('sort', filter.sort);
			params.set('dir', filter.dir === 'DESC' ? 'DESC' : 'ASC');
		}
		return this.http.get(`${this.configService.companiesUrl}cert-payment/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cert-payment/get/${origin}/${ctp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddCertPayment(ctp: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}cert-payment/add`, ctp, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdCertPayment(origin: string, ctp_id: number, ctp: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/upd/${origin}/${ctp_id}`, ctp, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}cert-payment/del/${origin}/${ctp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	FirmaCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/firma/${origin}/${ctp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Scarica il PDF del CertPag come Blob (per allegarlo a FormData del modulo mail). */
	GetCertPaymentPdfBlob(origin: string, ctp_id: number): Observable<Blob> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cert-payment/pdf-blob/${origin}/${ctp_id}`, { responseType: 'blob' }).pipe(finalize(() => this.spinnerService.hide()));
	}

	InviaCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/invia/${origin}/${ctp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AssociaCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/associa/${origin}/${ctp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Collega la fattura attiva generata al CdP (ctp_fat_id + stato Associato). */
	LinkCertPaymentInvoice(origin: string, ctp_id: number, fat_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/link-invoice/${origin}/${ctp_id}/${fat_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Elimina la fattura attiva collegata al CdP e la scollega (bloccata se rate pagate). */
	DeleteCertPaymentLinkedInvoice(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}cert-payment/linked-invoice/${origin}/${ctp_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	ResetCertPayment(origin: string, ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment/reset/${origin}/${ctp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Svincolo Ritenute (replica DNN svincolaCert).
	 * Crea automaticamente nuovo SAL + nuovo CertPag tipologia SVINCOLO, aggrega
	 * ritenute dei certificati precedenti dello stesso SAL/fornitore, marca svincolati.
	 * Ritorna { new_sal_id, new_cert_id, ritenuta_totale, certificati_svincolati: [...] }.
	 */
	SvincolaCertPayment(ctp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}cert-payment/svincola/${ctp_id}`, {}, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// =============== Contratti applicativi (lookup per dropdown) ===============

	/** Lista Gestione contratti paginata e ordinata sul server (sort: descrizione|codice|importo|data; offset = righe da saltare) */
	GetCertPaymentContractsPage(cmp_id: number, txtsearch: string, limit: number, offset: number, sort: string, dir: string): Observable<any> {
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		if (txtsearch) params.set('txtsearch', txtsearch);
		params.set('limit', String(limit));
		params.set('offset', String(offset));
		if (sort) {
			params.set('sort', sort);
			params.set('dir', dir || 'ASC');
		}
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/list?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetCertPaymentContractsList(cmp_id: number, txtsearch: string = '', ws_id: number | null = null, limit: number = 20000): Observable<any> {
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		if (txtsearch) params.set('txtsearch', txtsearch);
		if (ws_id) params.set('ws_id', String(ws_id));
		params.set('limit', String(limit));
		params.set('offset', '0');
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/list?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/**
	 * Lista unica della pagina "Gestione Contratti": contratti del portale + contratti RFI (campo origin 'general' / 'em' /
	 * 'lo'). I contratti RFI arrivano solo dove l'HelpDesk RFI e' attivo per l'azienda. Per le tendine resta
	 * GetCertPaymentContractsList (solo contratti del portale).
	 */
	GetContrattiListaUnica(cmp_id: number, txtsearch: string = '', origin: string = ''): Observable<any> {
		const params = new URLSearchParams();
		params.set('cmp_id', String(cmp_id));
		if (txtsearch) params.set('txtsearch', txtsearch);
		if (origin) params.set('origin', origin);
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/list-unica?${params.toString()}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	// =============== Gestione Contratti applicativi (CRUD companies) ===============

	/** Contratto completo (header + categorie/trattenute/anticipazioni/subappalti/varianti) per l'edit. */
	GetCertPaymentContractFull(cnt_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/full/${cnt_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddCertPaymentContract(contract: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}cert-payment-contracts/add`, contract, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdCertPaymentContract(cnt_id: number, contract: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}cert-payment-contracts/upd/${cnt_id}`, contract, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DelCertPaymentContract(cnt_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}cert-payment-contracts/del/${cnt_id}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Elimina un contratto RFI con il servizio RFI di sempre; headers della regione da RfiNavigationService.inRegione. */
	DelContrattoRfi(cnt_id: number, headers: { [k: string]: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.urlRFIService}gestione_contratto_del/${cnt_id}`, { headers, observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Numero di certificati RFI di un contratto RFI (lista RFI di sempre, filtro contratto); headers della regione da RfiNavigationService.inRegione. */
	CountCertPagamentoRfiDelContratto(cnt_id: number, headers: { [k: string]: string }): Observable<number> {
		const filtro = new Certificati_Pagamento_Filtro();
		filtro.cnt_id = String(cnt_id);
		filtro.pagina = 1;
		filtro.righePagina = 1;
		return this.http.post<any>(`${this.configService.urlRFIService}certificati_pagamento_lista`, filtro, { headers }).pipe(map((r) => Number(r?.total_rows) || (r?.data?.length ?? 0)));
	}

	/**
	 * Elimina un certificato RFI con il servizio RFI di sempre (GET certificati_pagamento_del, come lo mappa il servizio);
	 * headers della regione da RfiNavigationService.inRegione. Risposta: 0 = eliminato, altrimenti il numero del
	 * certificato successivo da eliminare prima.
	 */
	DelCertPagamentoRfi(ctp_id: number, headers: { [k: string]: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.urlRFIService}certificati_pagamento_del/${ctp_id}`, { headers, observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** "Invia PDF" di un certificato RFI con il servizio RFI di sempre (PDF e destinatari del portale della regione). Risposta { res: nome file in temp }. */
	InviaCertPagamentoRfi(ctp_id: number, companyID: number, headers: { [k: string]: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.urlRFIService}certificato_pagamento_stampa/${ctp_id}/true?companyID=${companyID}`, {}, { headers, observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Lookup categorie SOA dell'azienda (per i picker del form contratto). */
	GetCertPaymentCategoriesList(cmp_id: number, txtsearch: string = ''): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}cert-payment-categories/list?txtsearch=${txtsearch}&order_by=&limit=20000&offset=0&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	GetListCategories(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}categories/listall?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getCategory(wfct_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}categories/get/${wfct_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	updateCategory(addcategoria: Category, wfct_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}categories/upd/${wfct_id}`;
		return this.http.put(this.mUrl, addcategoria, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	addCategory(addcategoria: Category, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}categories/add/${cmp_id}`;
		return this.http.post(this.mUrl, addcategoria, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksite(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}worksite/get/${ws_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	/**
	 * Codice della commessa nel gestionale di officina (serramenti).
	 * Viaggia da solo perche' non e' nel model condiviso `Worksite` del backend:
	 * e' un campo del solo gruppo `manifatturiero`, non vale una versione nuova
	 * della libreria comune a tutti i servizi.
	 */
	GetWorksiteRifCad(ws_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}worksite/rif-cad/${ws_id}`, { observe: 'response', responseType: 'text' }).pipe(map((response) => (response.body as string) || ''));
	}

	SetWorksiteRifCad(ws_id: number, codice: string): Observable<any> {
		return this.http
			.put(`${this.configService.companiesUrl}worksite/rif-cad/${ws_id}?codice=${encodeURIComponent(codice || '')}`, null, {
				observe: 'response',
			})
			.pipe(map((response) => response.body));
	}

	addUpdWorksite(ws: Worksite, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/add/${cmp_id}`;
		return this.http.post(this.mUrl, ws, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Le province non cambiano: si leggono una volta sola e le tendine Provincia condividono la risposta
	private province$: Observable<any> | null = null;

	getProvinceList(): Observable<any> {
		this.province$ ??= this.http
			.get(`${this.configService.companiesUrl}worksite/province/list`, {
				observe: 'response',
				headers: { 'X-No-Spinner': 'true' },
			})
			.pipe(
				map((response) => response.body),
				catchError((err) => {
					this.province$ = null; // errore: la prossima tendina riprova
					return throwError(() => err);
				}),
				shareReplay(1),
			);
		return this.province$;
	}

	getStampa_QRCode_pdf(ws_id: number, type: string): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}pdf/worksite_qrcode/${ws_id}?type=${type}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetListSuppliers(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		// showSpinner = false vale anche per lo spinner dell'interceptor (header X-No-Spinner): senza,
		// ogni apertura/ricerca delle tendine fornitore mostrava il loader globale
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		// encodeURIComponent: senza, un & nel nome (es. "GmbH & Co. KG") tronca il parametro txtsearch
		return this.http.get(`${this.configService.companiesUrl}suppliers/list?txtsearch=${encodeURIComponent(txtsearch || '')}&order_by=${encodeURIComponent(order_by || '')}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	/** filterEnabled: 1 = attivi (default), 2 = disabilitati (cancellati logicamente). */
	GetListEmployees(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, filterWrStatus: number = 0, filterRoleId: number = 0, filterEnabled: number = 1): Observable<any> {
		this.spinnerService.show();
		let url = `${this.configService.companiesUrl}employees/list?txtsearch=${encodeURIComponent(txtsearch)}&order_by=${encodeURIComponent(order_by)}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`;
		if (filterWrStatus > 0) url += `&filter_wr_status=${filterWrStatus}`;
		if (filterRoleId > 0) url += `&filter_role_id=${filterRoleId}`;
		url += `&filter_enabled=${filterEnabled}`;
		return this.http.get(url, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListRoles(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}roles/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Logo azienda on-demand: le liste non trasportano piu' cmp_logo_b64 (payload ~522kB/azienda)
	GetCompanyLogo(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}companies/logo/${cmp_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	GetCompany(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}companies/get?cmp_id=${cmp_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetCompanyDetail(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}companies/getdetail?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetRole(rl_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}roles/get?rl_id=${rl_id}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetEmployee(emp_id: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/get?emp_id=${emp_id}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Accoda al notificatore la mail con l'elenco dei documenti mancanti/scaduti del dipendente. */
	NotifyEmployeeDocs(em_id: number, docs: { label: string; stato: string; scadenza: string | null }[]): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}employees/docs/notify?em_id=${em_id}`, docs, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Import lista paghe (PDF): confronta col'anagrafica e ritorna le sole anomalie (Fase 1). */
	uploadPayrollCompare(file: File, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		const fd = new FormData();
		fd.append('file', file);
		fd.append('cmp_id', String(cmp_id));
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/compare`, fd, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Inserisce/aggiorna il codice fiscale di un dipendente (lista "Senza CF"). */
	setEmployeeCf(em_id: number, cf: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ em_id: String(em_id), cf }).toString();
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/set-cf?${params}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Ultimo import "lista dipendenti attivi" dell'azienda, ricalcolato sull'anagrafica attuale (null = nessun import). */
	getPayrollReport(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}employees/payroll/report?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}
	/** Salva il report di import dell'azienda (stato delle scelte dell'operatore). */
	savePayrollReport(cmp_id: number, report: any[]): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/report?cmp_id=${cmp_id}`, report, { observe: 'response' }).pipe(map((r) => r.body));
	}
	/** "Carica un altro file": elimina report e righe del file salvate. */
	deletePayrollReport(cmp_id: number): Observable<any> {
		return this.http.delete(`${this.configService.companiesUrl}employees/payroll/report?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	/** MANCANTE: crea il dipendente dal file (+ rapporto se con_rapporto). Ritorna em_id. */
	createMissingEmployee(cmp_id: number, cognome_nome: string, cf: string, dt_ass: string, dt_lic: string | undefined, con_rapporto: boolean): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ cmp_id: String(cmp_id), cognome_nome, con_rapporto: String(con_rapporto) });
		if (cf) params.set('cf', cf);
		if (dt_ass) params.set('dt_ass', dt_ass);
		if (dt_lic) params.set('dt_lic', dt_lic);
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/create-missing?${params.toString()}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Aggiorna in automatico nome/cognome del dipendente dai dati del file. */
	updateEmployeeName(em_id: number, cognome_nome: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ em_id: String(em_id), cognome_nome }).toString();
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/update-name?${params}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Proroga (nuovo rapporto di lavoro) dal giorno dopo la fine del rapporto attivo a dt_end. */
	prorogaRapporto(cwr_id: number, dt_end: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ cwr_id: String(cwr_id), dt_end });
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/proroga?${params.toString()}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Licenziamento senza UNILAV: chiude il rapporto (data indicata o, se assente, ieri). */
	terminateRapporto(cwr_id: number, dt?: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ cwr_id: String(cwr_id) });
		if (dt) params.set('dt', dt);
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/terminate?${params.toString()}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Riapre il rapporto (azzera la data fine): file lo dà attivo ma l'anagrafica è chiusa. */
	reopenRapporto(cwr_id: number): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ cwr_id: String(cwr_id) }).toString();
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/reopen?${params}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Crea un job workflow HR (Assunzione/Licenziamento con UNILAV). Ritorna il wfj_id (stringa). */
	createPayrollHrJob(cmp_id: number, fg_name: string, descrizione: string, em_id?: number, cf?: string, nome?: string, cognome?: string): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams({ cmp_id: String(cmp_id), fg_name, descrizione });
		if (em_id) params.set('em_id', String(em_id));
		if (cf) params.set('cf', cf);
		if (nome) params.set('nome', nome);
		if (cognome) params.set('cognome', cognome);
		// l'endpoint ritorna il wfj_id come stringa pura (non JSON): responseType 'text' o HttpClient va in errore di parse
		return this.http.post(`${this.configService.companiesUrl}employees/payroll/create-job?${params.toString()}`, null, { responseType: 'text' }).pipe(finalize(() => this.spinnerService.hide()));
	}

	GetSupplier(sup_id: number, cmp_id: number, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		return this.http.get(`${this.configService.companiesUrl}suppliers/get?sup_id=${sup_id}&cmp_id=${cmp_id}`, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	loadSupplierUsers(supplierId: number): Observable<any> {
		return this.http
			.get(`${this.configService.companiesUrl}suppliers/${supplierId}/utenti`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	addUserToSupplier(supplierId: number, user: User): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}suppliers/${supplierId}/utente/${user.usr_id}/add`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	removeUserFromSupplier(departmentId: number, user: User): Observable<any> {
		return this.http.delete(`${this.configService.companiesUrl}suppliers/${departmentId}/utente/${user.usr_id}/remove`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetRolesByEmployeeList(cmp_id: number, em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}roles/roleslist?cmp_id=${cmp_id}&em_id=${em_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Ruoli azienda con flag assegnazione per un collaboratore (di fornitore o di cliente)
	GetRolesByCollaboratorList(cmp_id: number, col_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}roles/roleslistcollaborator?cmp_id=${cmp_id}&col_id=${col_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addRoleCollaborator(cmp_id: number, col_id: number, rl: Role): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}roles/addcollaborator?cmp_id=${cmp_id}&col_id=${col_id}`, rl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteRoleCollaborator(col_id: number, rl_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}roles/delcollaborator?col_id=${col_id}&rl_id=${rl_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetRolesByUserList(cmp_id: number, user_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}roles/roleslistbyuser?cmp_id=${cmp_id}&user_id=${user_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	addUpdCompany(cmp: Company): Observable<any> {
		this.spinnerService.show();
		this.mUrl = cmp.id > 0 ? `${this.configService.companiesUrl}companies/upd` : `${this.configService.companiesUrl}companies/add`;
		return this.http.post(this.mUrl, cmp, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addUpdSupplier(sup: Supplier): Observable<any> {
		this.spinnerService.show();
		this.mUrl = sup.id > 0 ? `${this.configService.companiesUrl}suppliers/upd` : `${this.configService.companiesUrl}suppliers/add`;
		return this.http.post(this.mUrl, sup, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addUpdRole(rl: Role): Observable<any> {
		this.spinnerService.show();
		this.mUrl = rl.rl_id > 0 ? `${this.configService.companiesUrl}roles/updrl` : `${this.configService.companiesUrl}roles/addrl`;
		return this.http.post(this.mUrl, rl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delCompany(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}companies/del`;
		return this.http.post(this.mUrl, cmp_id, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Il vincolo a DB torna come 409 KCS| dal backend: il messaggio lo mostra l'interceptor
	delCollaborator(col_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}collaborators/del/${col_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delCategorie(wfct_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}categories/del/${wfct_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Cancellazione LOGICA: disabilita il dipendente, che resta visibile filtrando i disabilitati. */
	delEmployee(emp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}employees/del/${emp_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Cancellazione FISICA: dipendente + ruoli, sedi, cantieri, rapporti di lavoro e cartella documentale. */
	delEmployeeFisico(emp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}employees/del_fisico/${emp_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Rimette fra gli attivi un dipendente disabilitato. */
	enableEmployee(emp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}employees/enable/${emp_id}`;
		return this.http.put(this.mUrl, {}, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delWorksite(ws_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}worksite/del/${ws_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delSupplier(sup_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}suppliers/del/${sup_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delRole(rl_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}roles/del/${rl_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addRole(cmp_id: number, em_id: number, rl: Role): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}roles/add?cmp_id=${cmp_id}&em_id=${em_id}`, rl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addRoleByUser(cmp_id: number, user_id: number, rl: Role, user_type: string): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}roles/addbyuser?cmp_id=${cmp_id}&user_id=${user_id}&usr_type=${user_type}`, rl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteRole(em_id: number, rl_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}roles/del?em_id=${em_id}&rl_id=${rl_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delRoleByUser(cmp_id: number, user_id: number, rl_id: number, user_type: string): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}roles/delbyuser?cmp_id=${cmp_id}&user_id=${user_id}&rl_id=${rl_id}&usr_type=${user_type}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListRuoli(cmp_id: number, cerca: string, orderby: string, limitda: number, limitper: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}ruoli/lista/${cmp_id}?${cerca}&orderby=${orderby}&limitda=${limitda}&limitper=${limitper}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SetEmployeeUser(usr_id: number, emp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/setuser/${usr_id}/${emp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	SetDoctorUser(usr_id: number, dc_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}doctors/setuser/${usr_id}/${dc_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SetCollaboratorUser(usr_id: number, col_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}collaborators/setuser/${usr_id}/${col_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getSettingsCompaniesAppointment(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}companies/get_settings_cmp_appointment/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	getAppointmentsList(filter: any): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/lista_appuntamenti`, filter, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	get_lstAppointmentState(): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}companies/lista_stati_appuntamenti`, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	addCompanyAppointment(cmp_id: number, data: any): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/add_appuntamento/${cmp_id}`, data, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	updCompanyAppointment(cmp_id: number, data: any): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/upd_appuntamento/${cmp_id}`, data, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	/* getCompanyCalendar(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}companies/get_calendar/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	} */

	saveCompanyCalendar(cmp_id: number, company_calendar: any): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/save_calendar/${cmp_id}`, company_calendar, { observe: 'response' }).pipe(
			map((response) => {
				return response.body;
			}),
		);
	}

	// Service Manager

	getServices(companyId: number): Observable<Service[]> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}company_service/manager/list?companyId=${companyId}`, { observe: 'response' }).pipe(
			map((response) => response.body as Service[]),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getServicesByUser(userId: number, companyId: number): Observable<Service[]> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}company_service/manager/list-by-user?userId=${userId}&companyId=${companyId}`, { observe: 'response' }).pipe(
			map((response) => response.body as Service[]),
			finalize(() => this.spinnerService.hide()),
		);
	}
	/* SEDI AZIENDA */

	getViewSedi(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}locations/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addService(service: Service, companyId: number): Observable<void> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}company_service/manager?companyId=${companyId}`, service, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetSede(of_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}locations/get?of_id=${of_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateService(srv_id: number, service: Service, companyId: number): Observable<void> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}company_service/manager/${srv_id}?companyId=${companyId}`, service, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addUpdSede(loc: Office): Observable<any> {
		this.spinnerService.show();
		this.mUrl = loc.of_id > 0 ? `${this.configService.companiesUrl}locations/upd` : `${this.configService.companiesUrl}locations/add`;
		return this.http.post(this.mUrl, loc, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getNextProtocol(cmp_id: number): Observable<any> {
		// il backend risponde con la stringa nuda (es. 26PR01) e non con JSON: senza
		// responseType 'text' HttpClient tenta JSON.parse, va in errore e il protocollo
		// della nuova sede resta vuoto
		return this.http.get(`${this.configService.companiesUrl}locations/next-protocol?cmp_id=${cmp_id}`, { observe: 'response', responseType: 'text' }).pipe(map((response) => response.body));
	}

	checkProtocolExists(cmp_id: number, protocol: string): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}locations/check-protocol?cmp_id=${cmp_id}&protocol=${protocol}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	deleteService(srv_id: number): Observable<void> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}company_service/manager/${srv_id}`, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteViewSede(sed_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(this.configService.companiesUrl + 'locations/del/' + sed_id, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getServicePresets(): Observable<ServicePreset[]> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}company_service/manager/presets`, { observe: 'response' }).pipe(
			map((response) => response.body as ServicePreset[]),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Categorie servizi (macrogruppi) per il select del form servizi
	getServiceCategories(): Observable<any[]> {
		return this.http.get(`${this.configService.companiesUrl}company_service/manager/categories`, { observe: 'response' }).pipe(map((response) => (response.body as any[]) || []));
	}

	// Get pages associated with a specific preset
	getPagesForPreset(presetId: number): Observable<Page[]> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}company_service/manager/presets/${presetId}/pages`, { observe: 'response' }).pipe(
			map((response) => response.body as Page[]),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Associate a preset with multiple pages
	associatePresetToPages(presetId: number, pageIds: number[]): Observable<void> {
		this.spinnerService.show();
		const payload = { prs_id: presetId, pg_ids: pageIds };
		return this.http.post(`${this.configService.companiesUrl}company_service/manager/presets/${presetId}/pages`, payload, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Remove preset association from a page
	removePresetFromPage(presetId: number, pageId: number): Observable<void> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}company_service/manager/presets/${presetId}/pages/${pageId}`, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Update preset page associations (replace all associations)
	updatePresetPageAssociations(presetId: number, pageIds: number[]): Observable<void> {
		this.spinnerService.show();
		const payload = { prs_id: presetId, pg_ids: pageIds };
		return this.http.put(`${this.configService.companiesUrl}company_service/manager/presets/${presetId}/pages`, payload, { observe: 'response' }).pipe(
			map(() => undefined),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListEmployeeWorkRelationships(txtsearch: string, order_by: string, limit: number, offset: number, emp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/work_relationships/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&em_id=${emp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	ChiudiRapporto(em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}employees/work_relationships/close/${em_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** HR manager dell'azienda (o superadmin), deciso dal backend: impersonando un utente il token ha solo GUEST */
	private hrManager = new Map<string, Observable<boolean>>();
	IsHrManager(cmp_id: number): Observable<boolean> {
		// chiave anche per utente: impersonando o cambiando utente la risposta cambia
		const chiave = cmp_id + '|' + (this.configService.getUser()?.token || '');
		if (!this.hrManager.has(chiave)) {
			this.hrManager.set(
				chiave,
				this.http.get<any>(`${this.configService.companiesUrl}employees/hr_manager/${cmp_id}`).pipe(
					map((r) => !!r?.hr_manager),
					catchError(() => of(false)),
					shareReplay(1),
				),
			);
		}
		return this.hrManager.get(chiave)!;
	}

	/** Documenti dei dipendenti scaduti o in scadenza entro `giorni` (widget; righe solo per HR manager e superadmin) */
	GetDocumentiScadenze(cmp_id: number, giorni = 90): Observable<any[]> {
		return this.http.get<any[]>(`${this.configService.companiesUrl}employees/documenti_scadenze/${cmp_id}?giorni=${giorni}`);
	}

	/** PAT INAIL piu' usato dall'azienda, proposto nel form del rapporto ('' se l'azienda non ne ha) */
	GetPatinailAzienda(cmp_id: number): Observable<string> {
		return this.http.get<any>(`${this.configService.companiesUrl}employees/work_relationships/patinail/${cmp_id}`).pipe(map((res) => res?.patinail || ''));
	}

	/** Mail del dipendente: accesso (= em_email) e comunicazioni */
	GetEmployeeEmails(em_id: number): Observable<any[]> {
		return this.http.get<any[]>(`${this.configService.companiesUrl}employees/emails/${em_id}`);
	}

	/** Salva le mail del dipendente: dopo il salvataggio del dipendente (la mail di accesso e' em_email) */
	SaveEmployeeEmails(em_id: number, mail: any[]): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}employees/emails/${em_id}`, mail);
	}

	/** "Non rinnovare" (scadenze HR): l'ultimo rapporto del dipendente e' cessato alla sua data fine */
	NonRinnovareRapporto(em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}employees/work_relationships/non_rinnovare/${em_id}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetEmployeeWorkRelationship(cwr_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/work_relationships/get/${cwr_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetWorkRelationshipActive(em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/work_relationships/get_active/${em_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddEmployeeWorkRelationships(wr: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}employees/work_relationships/add`, wr, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdEmployeeWorkRelationships(wr: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}employees/work_relationships/upd`, wr, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorkRelationshipLevelsByCompany(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/work_relationships_level/list/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddWorkRelationshipLevel(cmp_id: number, description: string): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}employees/work_relationships_level/add`, { cwrl_cmp_id: cmp_id, cwrl_description: description }, { observe: 'response' }).pipe(map((response) => response.body));
	}

	UpdateWorkRelationshipLevel(cwrl_id: number, description: string): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}employees/work_relationships_level/upd`, { cwrl_id: cwrl_id, cwrl_description: description }, { observe: 'response' }).pipe(map((response) => response.body));
	}

	DeleteWorkRelationshipLevel(cwrl_id: number): Observable<any> {
		return this.http.delete(`${this.configService.companiesUrl}employees/work_relationships_level/del/${cwrl_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	// COMUNI

	getComuni(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(this.configService.companiesUrl + 'locations/get_comuni', { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getOrgType(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(this.configService.companiesUrl + 'locations/org_type/' + cmp_id, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getNaturaImpresa(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(this.configService.companiesUrl + 'companies/get_natura_impresa', { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	// Lookup gruppi funzionali disponibili (cmp_groups)
	GetCompanyGroups(): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}companies/groups`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	// Gruppo funzionale dell'azienda (standard | condominio)
	GetCompanyGroup(cmp_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}companies/getgroup?cmp_id=${cmp_id}`, { responseType: 'text' });
	}

	SetCompanyGroup(cmp_id: number, cmp_group: string): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}companies/setgroup?cmp_id=${cmp_id}&cmp_group=${cmp_group}`, null, { responseType: 'text' }).pipe(finalize(() => this.spinnerService.hide()));
	}

	getChatMode(cmp_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}companies/chatmode?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r: any) => r.body?.cmp_chat_mode || 'COMPANY'));
	}

	/**
	 * Modalita' chat + appartenenza dell'utente all'azienda: serve alla chat per sapere
	 * se "Nuova Conversazione" deve cercare utenti (DIRECT), aprire la chat con l'azienda
	 * (COMPANY, utente non membro = cliente) o non proporre nulla (COMPANY, membro).
	 * is_member assente (backend non aggiornato) = membro, cioe' il comportamento prudente:
	 * non crea conversazioni azienda<->cliente a nome di un dipendente.
	 */
	getChatContext(cmp_id: number, silent: boolean = false): Observable<ChatContext> {
		const headers = silent ? { 'X-No-Spinner': 'true' } : undefined;
		return this.http.get(`${this.configService.companiesUrl}companies/chatmode?cmp_id=${cmp_id}`, { observe: 'response', headers }).pipe(
			map((r: any) => ({
				mode: r.body?.cmp_chat_mode || 'COMPANY',
				isMember: r.body?.is_member !== false,
			})),
		);
	}

	setChatMode(cmp_id: number, mode: string): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}companies/chatmode`, { cmp_id, mode }, { observe: 'response' }).pipe(
			map((r: any) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Posizione menu portale (left | top) - tab Impostazioni anagrafica
	getMenuLayout(cmp_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}companies/menulayout?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r: any) => r.body?.cmp_menu_layout || 'left'));
	}

	setMenuLayout(cmp_id: number, layout: string): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}companies/menulayout`, { cmp_id, layout }, { observe: 'response' }).pipe(
			map((r: any) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Sfondi personalizzati (JSON) - tab Impostazioni anagrafica.
	// Niente spinner: il salvataggio e' un autosave in background dall'editor.
	getBranding(cmp_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}companies/branding?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r: any) => r.body?.cmp_branding || ''));
	}

	setBranding(cmp_id: number, branding: string): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/branding`, { cmp_id, branding }, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	// Organizzazione menu personalizzata (JSON) - tab Impostazioni anagrafica.
	/**
	 * Numeri del cruscotto Aziende in una chiamata (SQL cmp_get_cruscotto_azienda): dipendenti attivi per
	 * tipologia di rapporto, distacchi in corso per cantiere, fornitori, clienti e clienti con cantiere aperto.
	 */
	getCruscottoAzienda(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}companies/cruscotto?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((r: any) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Presenze per giorno del mese (SQL cmp_get_presenze_mese): [{ giorno 'YYYY-MM-DD', presenti, ore }]. */
	getPresenzeMese(cmp_id: number, mese: string): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}companies/presenze-mese?cmp_id=${cmp_id}&mese=${mese}`, { observe: 'response' }).pipe(
			map((r: any) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Niente spinner: il salvataggio e' un autosave in background dall'editor.
	getMenuOrg(cmp_id: number): Observable<string> {
		return this.http.get(`${this.configService.companiesUrl}companies/menuorg?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((r: any) => r.body?.cmp_menu_org || ''));
	}

	setMenuOrg(cmp_id: number, menuorg: string): Observable<any> {
		return this.http.post(`${this.configService.companiesUrl}companies/menuorg`, { cmp_id, menuorg }, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	getTipologiaImpresa(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(this.configService.companiesUrl + 'companies/get_tipologia_impresa', { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetSupplierSectors(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}suppliers/sectors?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getCCNL(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(this.configService.companiesUrl + 'companies/get_ccnl', { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getComuniSelect(filterValue: string, codiceProvincia?: string, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		// showSpinner = false vale anche per lo spinner dell'interceptor (header X-No-Spinner), come GetListSuppliers:
		// la tendina Comune cerca a ogni tasto
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		let url = this.configService.companiesUrl + 'locations/get_comuniselect?filterValue=' + encodeURIComponent(filterValue);
		if (codiceProvincia) url += '&codiceProvincia=' + encodeURIComponent(codiceProvincia);
		return this.http.get(url, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	// Contratto Cantiere Quota
	getQuotaByWorksite(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}contratto_quota/by_worksite/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** origin = archivio del contratto: 'general' = contratti del portale, 'em' / 'lo' = contratti RFI (stesso numero, altro contratto). */
	getQuotaByContract(contract_id: number, origin: 'general' | 'em' | 'lo' = 'general'): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}contratto_quota/by_contract/${contract_id}?origin=${origin}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getCategoriesByContract(contract_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}cert-payment-contracts/full/${contract_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	saveContrattoQuota(data: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}contratto_quota/save`, data, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteContrattoQuota(ccq_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}contratto_quota/del/${ccq_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getDescendants(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}schede-cantieri/descendants/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// Rapportini

	GetListReport(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}report/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delReport(wsrp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}report/del/${wsrp_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addUpdWorksiteReport(cmp_id: number, wsrp: WorksiteReport): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}report/add/${cmp_id}`;
		return this.http.post(this.mUrl, wsrp, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksiteReport(wsrp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}report/get/${wsrp_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetReportWorkplacebyType(id: number, type: string, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(`${this.configService.companiesUrl}report/get_by_type/${id}/${type}/${cmp_id}`, {
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	CompilaRapportino(id_out: number, wsrp: WorksiteReport): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}report/compila_report/${id_out}`;
		return this.http.post(this.mUrl, wsrp, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/* ───────────────────────────────────────────────
	   Rapportino Giornaliero Capo Squadra
	   ─────────────────────────────────────────────── */

	/** sort: 'data' | 'cantiere' | 'nome'; senza sort il server ordina per data decrescente */
	GetDailyReportList(cmp_id: number, ws_id: number, date_from: string, date_to: string, status: number, order_by: string, limit: number, offset: number, sort = '', dir = ''): Observable<any> {
		this.spinnerService.show();
		const ord = sort ? `&sort=${encodeURIComponent(sort)}&dir=${encodeURIComponent(dir)}` : '';
		return this.http.get(`${this.configService.companiesUrl}daily-report/list?cmp_id=${cmp_id}&ws_id=${ws_id}&date_from=${date_from}&date_to=${date_to}&status=${status}&order_by=${encodeURIComponent(order_by)}&limit=${limit}&offset=${offset}${ord}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetDailyReport(wsrerp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/get/${wsrerp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveDailyReport(cmp_id: number, report: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}daily-report/save/${cmp_id}`, report, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DeleteDailyReport(wsrerp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}daily-report/del/${wsrerp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetDailyReportCalendar(ws_id: number, cmp_id: number, year: number, month: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/calendar/${ws_id}/${cmp_id}?year=${year}&month=${month}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	ExportDailyReportExcel(cmp_id: number, ws_id: number, date_from: string, date_to: string, status: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/export/excel?cmp_id=${cmp_id}&ws_id=${ws_id}&date_from=${date_from}&date_to=${date_to}&status=${status}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Riepilogo mensile personale (Excel): dipendenti in riga, giorni in colonna, totali O/S/N/SN. Ritorna l'ExportJob. */
	ExportDailyReportRiepilogoMensile(cmp_id: number, ws_id: number, date_from: string, date_to: string, status: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/export/riepilogo-mensile?cmp_id=${cmp_id}&ws_id=${ws_id}&date_from=${date_from}&date_to=${date_to}&status=${status}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	ExportDailyReportPdf(cmp_id: number, ws_id: number, date_from: string, date_to: string, status: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/export/pdf?cmp_id=${cmp_id}&ws_id=${ws_id}&date_from=${date_from}&date_to=${date_to}&status=${status}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	FindDailyReportByKey(ws_id: number, date: string): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}daily-report/find?ws_id=${ws_id}&date=${date}`, { observe: 'response' }).pipe(map((r) => r.body));
	}

	GetWorksiteRoleInfo(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/role-info?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	GetHistoricalWorksites(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/historical-worksites?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetDailyReportPrefill(ws_id: number, cmp_id: number, date: string): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}daily-report/prefill/${ws_id}/${cmp_id}?date=${date}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** soloAttivi=true: solo banche con IBAN valorizzato e attivo (dove la banca va scelta per pagare). */
	getBanks(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, sup_id: number, soloAttivi: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}banks/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&sup_id=${sup_id}&solo_attivi=${soloAttivi}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	delBanks(cb_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}banks/del/${cb_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetBank(cb_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}banks/get?cb_id=${cb_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	addUpdBank(bank: Banks): Observable<any> {
		this.spinnerService.show();
		this.mUrl = bank.cb_id > 0 ? `${this.configService.companiesUrl}banks/upd` : `${this.configService.companiesUrl}banks/add`;
		return this.http.post(this.mUrl, bank, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Conto flussi di pagamento collegato alla banca (sf_banche_pagamenti_flussi) */
	getBankBpf(cb_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}banks/bpf?cb_id=${cb_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	/** Aggiorna i dati tecnici flussi del conto collegato alla banca */
	updBankBpf(cb_id: number, bpf: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}banks/bpf/upd`, { cb_id, bpf }, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// ----------------------------------------------------------------
	// Configurazioni pagamento per azienda (ws_spring_payment)
	// ----------------------------------------------------------------
	getPaymentConfigs(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.paymentUrl}company-config/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getPaymentConfig(pcc_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.paymentUrl}company-config/get?pcc_id=${pcc_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getPaymentConfigSecret(pcc_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.paymentUrl}company-config/secret/${pcc_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	addUpdPaymentConfig(cfg: PaymentConfig): Observable<any> {
		this.spinnerService.show();
		this.mUrl = cfg.pcc_id > 0 ? `${this.configService.paymentUrl}company-config/upd` : `${this.configService.paymentUrl}company-config/add`;
		return this.http.post(this.mUrl, cfg, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	delPaymentConfig(pcc_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.paymentUrl}company-config/del/${pcc_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getDoctors(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}doctors/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	delDoctor(dc_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}doctors/del/${dc_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetDoctor(dc_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}doctors/get?dc_id=${dc_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	addUpdDoctor(doctor: Doctors): Observable<any> {
		this.spinnerService.show();
		this.mUrl = doctor.dc_id > 0 ? `${this.configService.companiesUrl}doctors/upd` : `${this.configService.companiesUrl}doctors/add`;
		return this.http.post(this.mUrl, doctor, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getWorksiteLocation(cmp_id: number, of_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}locations/listaworksitelocation?cmp_id=${cmp_id}&of_id=${of_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListDetached(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}detached/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssWorksite(of_id: number, worksite: Worksite): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}locations/saveassworksitelocation?of_id=${of_id}`, worksite, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	DelDetached(cmp_ws_col_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}detached/del/${cmp_ws_col_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getEmployeeLocation(cmp_id: number, of_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}locations/listaemployeelocation?cmp_id=${cmp_id}&of_id=${of_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetDetached(cmp_ws_col_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}detached/get?cmp_ws_col_id=${cmp_ws_col_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssEmployee(of_id: number, employee: Employee): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}locations/saveassemployeelocation?of_id=${of_id}`, employee, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	addUpdDetached(det: Detached): Observable<any> {
		this.spinnerService.show();
		this.mUrl = det.cmp_ws_col_id > 0 ? `${this.configService.companiesUrl}detached/upd` : `${this.configService.companiesUrl}detached/add`;
		return this.http.post(this.mUrl, det, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getLocationEmployee(cmp_id: number, em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/listalocationemployee?cmp_id=${cmp_id}&em_id=${em_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssLocationtoEmployee(em_id: number, loc: Office): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}employees/saveasslocationemployee?em_id=${em_id}`, loc, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getLocationWorksite(cmp_id: number, ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/listalocationworksite?cmp_id=${cmp_id}&ws_id=${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssLocationtoWorksite(ws_id: number, loc: Office): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/saveasslocationworksite?ws_id=${ws_id}`, loc, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// === Associazioni cantiere-dipendente con date ===
	GetEmployeesAssoc(cmp_id: number, ws_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/employees-assoc/${cmp_id}/${ws_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveEmployeesAssoc(payload: { wsId: number; emId: number; dateStart: string; dateEnd?: string | null; forceExtend?: boolean }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/employees-assoc/save`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	RemoveEmployeesAssoc(payload: { wsId: number; emId: number }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/employees-assoc/remove`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	UpdateEmployeesAssoc(payload: { assocId: number; dateStart: string; dateEnd?: string | null }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/employees-assoc/update`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// === Cantiere-Collaboratore ===
	GetCollaboratorsAssoc(cmp_id: number, ws_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/collaborators-assoc/${cmp_id}/${ws_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	SaveCollaboratorsAssoc(payload: { wsId: number; colId: number; dateStart: string; dateEnd?: string | null; forceExtend?: boolean }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/collaborators-assoc/save`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	RemoveCollaboratorsAssoc(payload: { wsId: number; colId: number }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/collaborators-assoc/remove`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	UpdateCollaboratorsAssoc(payload: { assocId: number; dateStart: string; dateEnd?: string | null }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/collaborators-assoc/update`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// === Sede-Dipendente ===
	GetOrgunitEmployeesAssoc(cmp_id: number, of_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/orgunit-employees-assoc/${cmp_id}/${of_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	SaveOrgunitEmployeesAssoc(payload: { ofId: number; emId: number; dateStart: string; dateEnd?: string | null; forceExtend?: boolean }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/orgunit-employees-assoc/save`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	RemoveOrgunitEmployeesAssoc(payload: { ofId: number; emId: number }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/orgunit-employees-assoc/remove`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	UpdateOrgunitEmployeesAssoc(payload: { assocId: number; dateStart: string; dateEnd?: string | null }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/orgunit-employees-assoc/update`, payload, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// === Reverse viste ===
	GetEmployeeWorksitesAssoc(cmp_id: number, em_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/employee-worksites-assoc/${cmp_id}/${em_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetEmployeeOrgunitsAssoc(cmp_id: number, em_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/employee-orgunits-assoc/${cmp_id}/${em_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	GetCollaboratorWorksitesAssoc(cmp_id: number, col_id: number, includeHistory: boolean = false): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/collaborator-worksites-assoc/${cmp_id}/${col_id}?include_history=${includeHistory}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getEmployeeWorksite(cmp_id: number, ws_id: number, refDate?: string): Observable<any> {
		this.spinnerService.show();
		const refQs = refDate ? `&ref_date=${refDate}` : '';
		return this.http.get(`${this.configService.companiesUrl}worksite/listaemployeeworksite?cmp_id=${cmp_id}&ws_id=${ws_id}${refQs}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssEmployeetoWorksite(ws_id: number, em: Employee): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/saveassemployeeworksite?ws_id=${ws_id}`, em, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getWorksiteEmployee(cmp_id: number, em_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}employees/listaworksiteemployee?cmp_id=${cmp_id}&em_id=${em_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssWorksitetoEmployee(em_id: number, ws: Worksite): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}employees/saveassworksiteemployee?em_id=${em_id}`, ws, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getCollaboratorWorksite(cmp_id: number, ws_id: number, refDate?: string): Observable<any> {
		this.spinnerService.show();
		const refQs = refDate ? `&ref_date=${refDate}` : '';
		return this.http.get(`${this.configService.companiesUrl}worksite/listacollaboratorworksite?cmp_id=${cmp_id}&ws_id=${ws_id}${refQs}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssCollaboratortoWorksite(ws_id: number, col: Collaborator): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/saveasscollaboratorworksite?ws_id=${ws_id}`, col, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getWorksiteCollaborator(cmp_id: number, col_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}collaborators/listaworksitecollaborator?cmp_id=${cmp_id}&col_id=${col_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SaveAssWorksitetoCollaborator(col_id: number, worksite: Worksite): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}collaborators/saveassworksitecollaborator?col_id=${col_id}`, worksite, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getEmployeeonWorksite(cmp_id: number, ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/listaemployeeonworksite?cmp_id=${cmp_id}&ws_id=${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getEmployeeonLocation(cmp_id: number, of_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}locations/listaemployeeonlocation?cmp_id=${cmp_id}&of_id=${of_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	ExportCustomersExcel(cmp_id: number, txtsearch: string = '', cst_type: number | null = null): Observable<Blob> {
		let url = `${this.configService.companiesUrl}customers/export-excel?cmp_id=${cmp_id}&txtsearch=${encodeURIComponent(txtsearch)}`;
		if (cst_type != null) url += `&cst_type=${cst_type}`;
		return this.http.get(url, { responseType: 'blob' });
	}

	GetListCustomers(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		// showSpinner = false vale anche per lo spinner dell'interceptor (header X-No-Spinner), come GetListSuppliers
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		// encodeURIComponent: senza, un & nel nome tronca il parametro txtsearch
		return this.http.get(`${this.configService.companiesUrl}customers/list?txtsearch=${encodeURIComponent(txtsearch || '')}&order_by=${encodeURIComponent(order_by || '')}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	getCustomer(cst_id: number, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		return this.http.get(`${this.configService.companiesUrl}customers/get?cst_id=${cst_id}`, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	addUpdCustomer(customer: Customer): Observable<any> {
		this.spinnerService.show();
		this.mUrl = customer.id > 0 ? `${this.configService.companiesUrl}customers/upd` : `${this.configService.companiesUrl}customers/add`;
		return this.http.post(this.mUrl, customer, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/* GARE */

	GetListGare(
		txtsearch: string,
		order_by: string,
		limit: number,
		offset: number,
		cmp_id: number,
		dataAggDa: string = '',
		dataAggA: string = '',
		stato: number = -1,
		anno: number = -1,
		tipologia: number = -1,
		customer: number = -1,
		indirizzoStazione: string = '',
		importoDa: number = -1,
		importoA: number = -1,
		categoria: number = -1,
	): Observable<any> {
		this.spinnerService.show();
		return this.http
			.get(
				`${this.configService.companiesUrl}gare/list?txtsearch=${txtsearch}&order_by=${order_by}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}&dataAggDa=${dataAggDa}&dataAggA=${dataAggA}&stato=${stato}&anno=${anno}&tipologia=${tipologia}&customer=${customer}&indirizzoStazione=${indirizzoStazione}&importoDa=${importoDa}&importoA=${importoA}&categoria=${categoria}`,
				{ observe: 'response' },
			)
			.pipe(
				map((response) => response.body),
				finalize(() => this.spinnerService.hide()),
			);
	}

	GetGara(lot_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/get/${lot_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addUpdGara(gara: Gara, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}gare/add/${cmp_id}`;
		console.log(gara.lst_lotti[0].lot_dataaggiudicazione);
		return this.http.post(this.mUrl, gara, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delLotto(lot_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}gare/del/${lot_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetTipoGaraList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/tipo_gara_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetModalitaAggiudicazioneList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/modalita_aggiudicazione_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetFormaPartecipazioneList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/forma_partecipazione_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetTipoPartecipazioneList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/tipo_partecipazione_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetClassificheList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/classifiche_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetCategorieList(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/categorie_list/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetGareaRiferimento(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/gare_a_riferimento_list/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetInvitiaRiferimento(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/inviti_a_riferimento_list/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	nextStepGara(cmp_id: number, lot_id: number, lot_stato: number, action: string): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/next_step/${cmp_id}/${lot_id}/${lot_stato}/${action}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	previousStepGara(lot_id: number, lot_stato: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/previous_step/${lot_id}/${lot_stato}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetStatiGara(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/stati_gara_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetAnniGare(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/anni_gare/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getTipologiaLavoroList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/tipologia_lavoro_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getFaseList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/fasi_worksite_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Senza cmp_id tornano anche gli stati riservati a un gruppo azienda (es. IN PRODUZIONE). */
	getWorksiteStateList(cmp_id: number = 0): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/stati_worksite_list?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getAliquotaIvaList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/aliquota_iva_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getRegimeIvaList(): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/regime_iva_list`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	getLastInfoGara(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}gare/get_last_info_gara/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Esporta in Excel la lista cantieri (stessi filtri della lista, tutte le pagine): ritorna l'ExportJob (PENDING). */
	ExportWorksiteListExcel(filter: { txtsearch?: string; stato?: number; cmp_id: number; lot_id?: number; categoria?: string }): Observable<any> {
		return this.exportWorksiteList('excel', filter);
	}

	/** PDF "Portafoglio lavori" della lista cantieri (stessi filtri della lista, tutte le pagine): ritorna l'ExportJob (PENDING). */
	ExportWorksiteListPdf(filter: { txtsearch?: string; stato?: number; cmp_id: number; lot_id?: number; categoria?: string }): Observable<any> {
		return this.exportWorksiteList('pdf', filter);
	}

	private exportWorksiteList(tipo: 'excel' | 'pdf', filter: { txtsearch?: string; stato?: number; cmp_id: number; lot_id?: number; categoria?: string }): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('txtsearch', filter.txtsearch || '');
		params.set('stato', String(filter.stato || 0));
		params.set('cmp_id', String(filter.cmp_id || 0));
		params.set('lot_id', String(filter.lot_id || 0));
		params.set('categoria', filter.categoria || '');
		return this.http.get(`${this.configService.companiesUrl}worksite/export/${tipo}?${params.toString()}`, { observe: 'response' }).pipe(
			map((r) => r.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getPdfDettaglioCantiere(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite/genera_pdf_cantiere_dettaglio/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/** Download asincrono di un DDT (file nel documentary): ritorna l'ExportJob (PENDING). */
	downloadDdtAsync(drflId: number, cmp_id: number = 0, label: string = ''): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmpId', String(cmp_id));
		if (label) params.set('label', label);
		return this.http.get(`${this.configService.companiesUrl}transport-document/download-ddt-async/${drflId}?${params.toString()}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getPDFDettaglioGara(lot_id: number, cmp_id: number = 0, label: string = ''): Observable<any> {
		this.spinnerService.show();
		const params = new URLSearchParams();
		params.set('cmpId', String(cmp_id));
		if (label) params.set('label', label);
		return this.http.get(`${this.configService.companiesUrl}gare/genera_pdf_gara_dettaglio/${lot_id}?${params.toString()}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateNoteGara(gr_id: number, gr_note: String): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}gare/upd_note_gara/${gr_id}`, gr_note, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateNoteWorksite(ws_id: number, ws_note: String): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/upd_note_worksite/${ws_id}`, ws_note, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	closeWorksite(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/close/${ws_id}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	SetEmployeeFolderId(emp_id: number, folder_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}employees/setfolderid/${emp_id}/${folder_id}`, null, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// DDT

	GetListDDT(
		txtsearch: string,
		order_by: string,
		limit: number,
		offset: number,
		cmp_id: number,
		associato: number = 0,
		emesso: number = 0,
		sup_id: number = 0,
		data_da: string = '',
		data_a: string = '',
		ws_id: number = 0,
		fat_id: number = 0,
		usr_id_ins: number = 0,
		showSpinner: boolean = true,
	): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		return this.http
			.get(`${this.configService.companiesUrl}transport-document/lista`, {
				headers,
				params: {
					txtsearch: txtsearch || '',
					order_by: order_by || '',
					limit: limit.toString(),
					offset: offset.toString(),
					cmp_id: cmp_id.toString(),
					associato: associato.toString(),
					emesso: emesso.toString(),
					sup_id: (sup_id || 0).toString(),
					data_da: data_da || '',
					data_a: data_a || '',
					ws_id: (ws_id || 0).toString(),
					fat_id: (fat_id || 0).toString(),
					usr_id_ins: (usr_id_ins || 0).toString(),
				},
				observe: 'response',
			})
			.pipe(
				map((response) => response.body),
				finalize(() => {
					if (showSpinner) this.spinnerService.hide();
				}),
			);
	}

	/** Utenti che compaiono sui DDT dell'azienda (voci del filtro Utente): [{usr_id, usr_name}]. */
	GetListDDTUtenti(cmp_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}transport-document/utenti`, { params: { cmp_id: cmp_id.toString() }, observe: 'response' }).pipe(map((response) => response.body));
	}

	/** DDT gia' inseriti con stesso fornitore, numero (anche scritto diversamente), data (yyyy-MM-dd) e cantiere (0 = senza): avviso doppione. */
	GetDDTDoppioni(cmp_id: number, sup_id: number, numero: string, data: string, ws_id: number): Observable<any> {
		return this.http
			.get(`${this.configService.companiesUrl}transport-document/doppioni`, {
				headers: { 'X-No-Spinner': 'true' },
				params: { cmp_id: cmp_id.toString(), sup_id: sup_id.toString(), numero, data, ws_id: (ws_id || 0).toString() },
				observe: 'response',
			})
			.pipe(map((response) => response.body));
	}

	delDDT(ddt_id: number): Observable<any> {
		this.spinnerService.show();
		this.mUrl = `${this.configService.companiesUrl}transport-document/delete/${ddt_id}`;
		return this.http.delete(this.mUrl, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetDDTById(ddtId: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}transport-document/${ddtId}`);
	}

	UpdateDDT(document: any): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}transport-document/update`, document, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AnnullaDDT(ddtId: number): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}transport-document/${ddtId}/annulla`, {}, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	RegenerateDDTPdf(ddtId: number, cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}transport-document/generate-pdf/${ddtId}?cmp_id=${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Ottiene i movimenti di magazzino disponibili per creare un DDT
	 */
	GetMovementsForDDT(cmp_id: number, txtsearch: string, limit: number, offset: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}transport-document/movements-for-ddt?cmp_id=${cmp_id}&txtsearch=${encodeURIComponent(txtsearch)}&limit=${limit}&offset=${offset}`, { observe: 'response' }).pipe(
			map((response: any) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	/**
	 * Ottiene il prossimo numero DDT suggerito
	 */
	GetNextDDTNumber(cmp_id: number, year?: number): Observable<string> {
		let url = `${this.configService.companiesUrl}transport-document/next-number?cmp_id=${cmp_id}`;
		if (year) url += `&year=${year}`;
		return this.http.get(url, { observe: 'response', responseType: 'text' }).pipe(map((response: any) => response.body));
	}

	/**
	 * Crea un DDT da movimenti di magazzino selezionati
	 */
	CreateDDTFromMovements(request: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}transport-document/create-from-movements`, request, { observe: 'response' }).pipe(
			map((response: any) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetListContracts(txtsearch: string, order_by: string, limit: number, offset: number, cmp_id: number, showSpinner: boolean = true): Observable<any> {
		if (showSpinner) this.spinnerService.show();
		// showSpinner = false vale anche per lo spinner dell'interceptor (header X-No-Spinner), come GetListSuppliers
		const headers = showSpinner ? undefined : { 'X-No-Spinner': 'true' };
		return this.http.get(`${this.configService.companiesUrl}companies/contratti?txtsearch=${encodeURIComponent(txtsearch || '')}&order_by=${encodeURIComponent(order_by || '')}&limit=${limit}&offset=${offset}&cmp_id=${cmp_id}`, { observe: 'response', headers }).pipe(
			map((response) => response.body),
			finalize(() => {
				if (showSpinner) this.spinnerService.hide();
			}),
		);
	}

	PrintLivel(request: { emp_id: number; cmp_id: number; data_inizio: string; livello: string; mansione: string }): Observable<string> {
		this.spinnerService.show();
		return this.http.post<{ res: string }>(`${this.configService.companiesUrl}employees/printlivel`, request, { observe: 'response' }).pipe(
			map((response) => response.body?.res as string),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// WORKSITE COST REPORT

	GetEmployeeDailyBreakdown(ws_id: number, em_id: number, start: string, end?: string | null): Observable<any> {
		this.spinnerService.show();
		const params = end ? `?start=${start}&end=${end}` : `?start=${start}`;
		return this.http.get(`${this.configService.companiesUrl}worksite-cost/personnel-daily/${ws_id}/${em_id}${params}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksiteCostReport(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite-cost/report/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksiteMaterialCosts(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite-cost/materials/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	GetWorksitePersonnelCosts(ws_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}worksite-cost/personnel/${ws_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// GALLERY

	GetCompanyGallery(cmp_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${this.configService.companiesUrl}company-gallery/list/${cmp_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	addTipologiaLavoro(payload: { tlv_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/tipologia_lavoro/add`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	AddGalleryPhoto(cmp_id: number, image_b64: string, caption: string, sort_order: number): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}company-gallery/add/${cmp_id}`, { image_b64, caption, sort_order }, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateTipologiaLavoro(id: number, payload: { tlv_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}worksite/tipologia_lavoro/update/${id}`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	DeleteGalleryPhoto(cg_id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}company-gallery/del/${cg_id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteTipologiaLavoro(id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}worksite/tipologia_lavoro/delete/${id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
	UpdateGalleryCaption(cg_id: number, caption: string): Observable<any> {
		return this.http.patch(`${this.configService.companiesUrl}company-gallery/caption/${cg_id}`, { caption }, { observe: 'response' }).pipe(map((response) => response.body));
	}

	addFase(payload: { fse_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/fase/add`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateFase(id: number, payload: { fse_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}worksite/fase/update/${id}`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteFase(id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}worksite/fase/delete/${id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// --- CRUD Stato Cantiere ---

	addStatoCantiere(payload: { ws_st_description: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/stato/add`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateStatoCantiere(id: number, payload: { ws_st_description: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}worksite/stato/update/${id}`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteStatoCantiere(id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}worksite/stato/delete/${id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	// --- Tipologia Contatto Cantiere ---

	getTipologiaContattoList(): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/tipologia_contatto/list`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	addTipologiaContatto(payload: { tcnt_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${this.configService.companiesUrl}worksite/tipologia_contatto/add`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	updateTipologiaContatto(id: number, payload: { tcnt_descrizione: string }): Observable<any> {
		this.spinnerService.show();
		return this.http.put(`${this.configService.companiesUrl}worksite/tipologia_contatto/update/${id}`, payload, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	deleteTipologiaContatto(id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.companiesUrl}worksite/tipologia_contatto/delete/${id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	getContattiByWorksite(ws_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/contatti/${ws_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}

	// --- Dipendenti del cantiere con ruoli (read-only, raggruppati per ruolo) ---
	getWorksiteEmployeesWithRoles(cmp_id: number, ws_id: number): Observable<any> {
		return this.http.get(`${this.configService.companiesUrl}worksite/employees-with-roles/${cmp_id}/${ws_id}`, { observe: 'response' }).pipe(map((response) => response.body));
	}
}
